import { useConditionBuilderStoreApi } from '../store';

export function useRemoveRule() {
  const store = useConditionBuilderStoreApi();

  return (id: string): void => {
    store.setState((state) => {
      state.condition.rules = state.condition.rules.filter((rule) => rule.id !== id);
    });
  };
}
